module.exports = __webpack_public_path__ + "static/img/nav_4.8c52401.svg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/nav_4.svg
// module id = 3WFZ
// module chunks = 2